import { RouteConfig } from 'vue-router';
import useI18n from '@/mixins/useI18n';
import { shouldUsePublicLandingpage } from '@/utils/publicSite';
import LandingpageSwitch from '@/views/public/landingpage/LandingpageSwitch.vue';
import Index from '../Index.vue';

const { t } = useI18n();
const usePublicLandingpage = shouldUsePublicLandingpage();
const indexTitle = usePublicLandingpage
  ? t('landingpage.title')
  : t('registration.meta.test_environment_title');
const indexDescription = usePublicLandingpage
  ? t('landingpage.meta')
  : t('registration.meta.test_environment_description');

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'index',
    component: usePublicLandingpage ? LandingpageSwitch : Index,
    meta: {
      layout: usePublicLandingpage ? 'landingpage' : 'login-register',
      title: indexTitle,
      description: indexDescription,
    },
  },
];

export default routes;
